/*!
* name ZJX  资源下载
* Copyright 2018-2019
*/
<template>
  <div v-show="loading">
    <div class="resourcedetails_content" style="padding-top:20px;">
      <div class="resourcedetails_tab_title">
        <span>
          乐画 >
          <a href="javascript:;" @click="goHomeList">作品分享</a>
        </span>
      </div>
      <div class="intro_title_row">
        <div class="intro_img">
          <img :src="resources.author.avatar || require('../../assets/images/head.png')" width="30" height="30" alt>
          <span>创作者：{{resources.author.name}}</span>
        </div>
        <div class="intro_title">
          <span class="title">{{resources.title}}</span>
          <span class="detail">{{resources.author.name}}{{creator}} 分享于<i>{{resources.created_at}}</i>
          作品ID：{{resources.wid}}</span>
        </div>
        <div class="intro_icon">
          <img src="../../assets/images/grade.png" alt="">
          <span>{{resources.type_name}}</span>
        </div>
        <!--<div class="intro_share" @click="handleShowShareDialog">分享</div>-->
      </div>
      <div class="intro_content">
        <div style="text-align:center">
          <img v-for="(item , index ) in resources.attachments" :key="index" :src="item.file_path" width="100%" alt
               style=" display:inline-block">
        </div>
        <div class="intro_je">
          <span class="intro_txt_span">
            <em class="yh_lf"></em>
            {{resources.content}}
            <em class="yh_rh"></em>
          </span>
          <span class="intro_top"></span>
        </div>

        <div v-if="!isTeacherSharing&&isShared" class="teacher_dp clearfix">
          <div class="teacher_dp_lf">
            <span class="my_py" @click="topModel"
                  v-if="isstudents && !isComment && (userName.name !== resources.author.name)&&(userId != resources.state_operator_id)">添加评语</span>
          </div>
          <ul class="teacher_li clearfix">
            <li>
              <div class="teacher_img">
                <img
                  :src="(resources.operator && resources.operator.avatar)? resources.operator.avatar : require('../../assets/images/head.png')"
                  width="80" height="80" alt>
              </div>
              <span class="teacher_user">- {{(resources.operator && resources.operator.name) ? resources.operator.name : ''}} -</span>
              <span class="teacher_fen">{{resources.score_num||10}}<em
                style="font-size:16px;vertical-align: 2px;padding-left: 5px;">分</em></span>
              <p class="teacher_intro_txt">{{resources.comment}}</p>
            </li>
            <li v-for="(item , index ) in resources.teacher_rates" :key="index">
              <div class="teacher_img">
                <img :src="item.author.avatar || require('../../assets/images/head.png')" width="80" height="80" alt>
              </div>
              <span class="teacher_user">- {{item.author.name}} -</span>
              <!--<span class="teacher_fen" v-if="index == 0">{{item.score_num||10}}<em-->
              <!--style="font-size:16px;vertical-align: 2px;padding-left: 5px;">分</em></span>-->
              <p class="teacher_intro_txt">{{item.comment}}</p>
            </li>

          </ul>
        </div>

        <div v-if="!isTeacherSharing&&isShared" class="teacher_dp clearfix">
          <div class="teacher_dp_rh">
            <template v-if="resources.student_average_score_num">
              <span class="score">{{resources.student_average_score_num}}</span>
              <span class="text">分</span>
            </template>
          </div>
          <ul class="teacher_li student_li clearfix">
            <li v-for="(item , index ) in resources.student_rates" :key="index">
              <div class="teacher_img student_img">
                <img
                  :src="item.author.avatar || require('../../assets/images/head.png')" width="60" height="60" alt>
              </div>
              <span class="teacher_user student_user">{{item.author.name}}</span>
              <span class="teacher_fen student_fen">评分：{{item.score_num}}分</span>
            </li>
          </ul>
        </div>

        <template v-if="!isRank&&!isTeacherSharing&&isShared">
          <span class="rsfe" v-if="isteachter">为他打分</span>
          <div class="block_fen clearfix" v-if="isteachter">
            <span>0分</span>
            <div class="block">
              <el-slider v-model="value2" :step="10" :format-tooltip="formatTooltip"></el-slider>
            </div>
            <span>10分</span>
          </div>
        </template>
        <el-button type="primary" @click="submitRate()" v-if="isteachter&&!isRank&&!isTeacherSharing&&isShared">提交
        </el-button>

        <div class="alert">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
            <el-dialog title="添加评语" :visible.sync="centerDialogVisible" width="120" center>
              <span>
                <el-form-item label>
                  <el-select v-model="ruleForm.region" placeholder="请选择作品评语" @change="selectChange">
                    <el-option :label="item.content" :value="item.content" v-for="(item , index ) in worksListData"
                               :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <!--<span style="display:block;padding-bottom:10px; cursor: pointer;" @click="isproupFun()">手动填写</span>-->
                <el-form-item label v-if="isproup">
                  <el-input v-model="ruleForm.name" placeholder="请输入评语文字"></el-input>
                </el-form-item>
              </span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
              </span>
            </el-dialog>
          </el-form>
        </div>
      </div>
      <div class="line" v-if="isShared">
        <div class="intro_share" v-if="isShared">
          <div @click="handleShowShareDialog">
            <img src="../../assets/images/share_icon.png">
            <span>分享</span>
          </div>
        </div>
      </div>
      <!-- region 分享弹窗 -->
      <el-dialog class="shareDialog"
        width="300px"
        center
        :show-close="false"
        :visible.sync="dialogShareShow">
        <div class="share-wrapper"
             v-show="!showCanvas"
             v-loading="canvasLoading"
             element-loading-text="拼命加载中"
        >
          <div class="bg-row"
               :style="styleObject">
            <img class="line-canvas" src="../../assets/images/share_bg@2x.png">
            <div class="picture">
              <img :src="shareImg ? shareImg :''">
            </div>
          </div>
          <div class="qrcode-row">
            <div class="text">乐画网精选作品<br/>分享让作画更快乐</div>
            <div id="qrcode" ref="qrcode"></div>
          </div>
          <img class="logo" src="../../assets/images/logo@2x.png">
        </div>
        <img class="share-canvas" :src="canvasSrc" v-show="showCanvas">
      </el-dialog>
      <!-- endregion 分享弹窗 -->
    </div>
  </div>
</template>

<script>
import cacheUtils from '@/common/cacheUtils' // 调用缓存
import apiInterface from '@/api/index' // 接口
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'

export default {
  data () {
    return {
      isproup: false,
      value2: 0,
      centerDialogVisible: false,
      isteachter: false,
      isstudents: true,
      worksListData: [],
      ruleForm: {
        name: '',
        region: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ]
      },
      resources: {
        author: {
          avatar: ''
        }
      },
      source: '',
      userName: '',
      userId: '',
      formData: '', // 存放workDetail接口的数据
      isRank: false, // 是否已评分
      isComment: false, // 是否已添加评语
      typeId: '',
      dialogShareShow: false,
      isTeacherSharing: false,
      isShared: false,
      shareImg: '',
      showCanvas: false,
      canvasSrc: '',
      canvasLoading: false,
      loading: false,
      creator: '' // 创作者 老师、学生
    }
  },
  computed: {
    styleObject () {
      return {
        backgroundImage: `url(${this.shareImg})`
      }
    }
  },
  mounted () {},
  components: {},
  created () {
    this.id = this.$route.query.id
    this.source = this.$route.query.source
    this.worksList()
    if (cacheUtils.sessionStorage('status').get('zjx') == 1) {
      this.isteachter = false
      this.isstudents = true
    } else {
      this.isteachter = true
      this.isstudents = false
    }
    this.accessPersonalInformation()
  },
  methods: {
    isproupFun () {
      this.isproup = true
      this.ruleForm.region = ''
    },
    topModel () {
      if (this.userName.name == this.resources.author.name) {
        this.$message.error('亲，不能给自己作品添加评语哦~')
        return
      }
      this.centerDialogVisible = true
      this.isproup = false
      this.ruleForm.name = ''
      this.ruleForm.region = ''
    },
    goHomeList () {
      if (this.source == 'zpj') {
        this.$router.push({
          path: '/personalcenter'
        })
      } else {
        this.$router.push({
          path: '/sharingcenter'
        })
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          try {
            // 老师作品评价，提交按钮
            this.$xhr
              .post(apiInterface.worksRate + this.id + '/rate', {
                type_id: cacheUtils.sessionStorage('status').get('zjx'),
                comment: this.ruleForm.name != '' ? this.ruleForm.name : this.ruleForm.region,
              })
              .then(res => {
                this.$message.success('评论成功')
                this.resetForm('ruleForm')
                this.worksDtelsData(this.id)
              })
              .catch(err => {})
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.centerDialogVisible = false
    },
    formatTooltip (val) {
      return val / 10
    },
    // 作品评语下拉框事件
    selectChange (value) {
      if (value) {
        this.ruleForm.name = ''
      }
    },
    // 分享弹窗
    handleShowShareDialog () {
      if (!this.shareImg) {
        this.$message.error('该作品没有图片，不能分享！')
        return
      }
      this.canvasLoading = true
      this.dialogShareShow = !this.dialogShareShow
      if (!this.canvasSrc) {
        let url = `http://${document.domain}/#/sharingcenterdetails?id=${this.id}`
        this.qrCode(url)
        this.drawCanvas()
      }
    },
    qrCode (url) {
      setTimeout(() => {
        document.querySelector('#qrcode').innerHTML = ''
        console.log('url:', url)
        new QRCode('qrcode', {
          text: url,
          render: 'canvas',
          width: 60,
          height: 60,
          colorDark: '#000000',
          colorLight: '#ffffff'
        })
      }, 2000)
    },
    drawCanvas () {
      const _this = this
      setTimeout(() => {
        _this.canvasLoading = false
        let $loading = document.querySelector('.el-loading-mask')
        $loading.parentNode.removeChild($loading)
        setTimeout(() => {
          html2canvas(document.querySelector('.share-wrapper')).then((canvas) => {
            let dataUrl = canvas.toDataURL('image/png', 1.0)
            _this.showCanvas = true
            _this.canvasSrc = dataUrl
          }, 2000)
        })
      }, 3000)
    },
    getBase64 (url, ext, callback) {
      var canvas = document.createElement('canvas') // 创建canvas DOM元素
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.src = url
      img.onload = function () {
        canvas.width = img.width // 指定画板的宽度，自定义
        canvas.height = img.height // 指定画板的高度,自定义
        ctx.drawImage(img, 0, 0, img.width, img.height) // 参数可自定义
        var dataURL = canvas.toDataURL('image/' + ext)
        callback.call(this, dataURL) // 回掉函数获取Base64编码
        canvas = null
      }
    },
    async worksDtelsData (item) {
      try {
        let pdata = await this.$xhr.get(apiInterface.worksDtels + item, { params: {} })
        this.formData = pdata
        this.resources = Object.assign({}, this.resources, pdata.data)
        this.shareImg = pdata.data.attachments && pdata.data.attachments.length > 0 ? pdata.data.attachments[0].file_path : ''
        const _this = this
        this.getBase64(this.shareImg, 'jpeg', function (base64) {
          // 给原生img对象的src属性赋值
          _this.shareImg = base64
        })
        // 判断上传者身份
        this.creator = pdata.data.author.type_id === 1 ? '老师' : '学生'
        if (pdata.data.is_student_created == 0) {
          this.isTeacherSharing = true
        }
        if (pdata.data.is_shared == 1) {
          this.isShared = true
        }
        if (this.typeId === 2) {
          // 学生不能对自己的作品评分以及同一作品不能重复评分
          this.isRank = pdata.data.user_id === this.userId
          let studentRates = pdata.data.student_rates
          if (studentRates) {
            studentRates.forEach(_o => {
              if (_o.user_id === this.userId) {
                this.isRank = _o.score_num >= 0
              }
            })
          }
        } else {
          this.isComment = pdata.data.user_id === this.userId
          let teacherRates = pdata.data.teacher_rates
          if (teacherRates) {
            teacherRates.forEach(_o => {
              if (_o.user_id === this.userId) {
                this.isComment = _o.comment.length > 0
              }
            })
          }
        }
        this.loading = true
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 作品类型
    async worksList () {
      try {
        let pdata = await this.$xhr.get(apiInterface.workComments, {
          params: {}
        })
        this.worksListData = pdata.data
        console.log(pdata.data)
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 学生作品评价，提交按钮
    async submitRate () {
      console.log()
      try {
        if (this.userId === this.formData.data.user_id) {
          this.$message.error('不能评价自己的作品')
          return
        }
        let pdata = await this.$xhr.post(
          apiInterface.worksRate + this.id + '/rate',
          {
            type_id: cacheUtils.sessionStorage('status').get('zjx'),
            score_num: this.value2 / 10
          }
        )
        this.$message.success('评分成功')
        if (pdata) {
          window.location.reload()
          // this.$router.go(0)
          // let _this = this
          // setTimeout(function () {
          //   _this.$router.go(0)
          // }, 500)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 获取个人信息内容
    async accessPersonalInformation () {
      if (cacheUtils.cookie.getObject('Token') != null) {
        try {
          let pdata = await this.$xhr.get(apiInterface.userInfo, {params: {}})
          this.userName = pdata.data.name
          this.userId = pdata.data.id
          this.typeId = pdata.data.type_id
        } catch (error) {
          console.log(error)
        }
      }
      this.worksDtelsData(this.id)
    }
  }
}
</script>

<style lang="scss">
.resourcedetails_content {
  box-sizing: border-box;
  padding-top: 480px;

  .intro_title_row {
    padding: 50px 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    font: 12px/30px Microsoft YaHei;
    color: #666;

    .intro_img {
      flex: 0 0 200px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }

    .intro_title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        text-align: center;
        font: 700 20px/36px Microsoft YaHei;
      }
    }

    .intro_icon {
      flex: 0 0 200px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .resourcedetails_tab_title {
    box-sizing: border-box;
    line-height: 15px;
    padding-left: 20px;
  }

  .intro_content {
    margin-top: -40px;
    padding-bottom: 100px;

    .intro_je {
      width: 960px;
      height: 120px;
      margin: 0 auto;
      position: relative;
      background: #f5f5f5;
      margin-top: 24px;
      text-align: center;

      .intro_txt_span {
        display: inline-block;
        height: 120px;
        font: 14px/120px "Microsoft YaHei";
        color: #000;
        padding: 0 120px;
        position: relative;

        .yh_lf {
          width: 120px;
          height: 120px;
          position: absolute;
          left: 0;
          top: 0;
          background: url(../../assets/images/quotation_mark1.png) no-repeat left 20px;
        }

        .yh_rh {
          width: 120px;
          height: 120px;
          position: absolute;
          right: 0;
          bottom: 0;
          background: url(../../assets/images/quotation_mark2.png) no-repeat right 80px;
        }
      }

      .intro_top {
        display: block;
        width: 30px;
        height: 14px;
        background: url(../../assets/images/intro_top.png) no-repeat center bottom;
        position: absolute;
        left: 50%;
        top: -14px;
        margin-left: -15px;
      }
    }

    .teacher_dp {
      padding-top: 40px;
      width: 960px;
      margin: 0 auto;

      .teacher_dp_lf {
        width: 274px;
        height: 290px;
        float: left;
        background: url(../../assets/images/teacher_grade.png) no-repeat center bottom;
        position: relative;

        .my_py {
          width: 74px;
          height: 28px;
          text-align: center;
          position: absolute;
          left: 50%;
          margin-left: -37px;
          bottom: 27px;
          display: block;
          font: 12px/28px "Microsoft YaHei";
          color: #15e4cb;
          border-radius: 15px;
          border: #15e4cb solid 1px;
          cursor: pointer;
        }
      }

      .teacher_dp_rh {
        width: 274px;
        height: 230px;
        display: flex;
        justify-content: center;
        align-items: center;
        float: left;
        position: relative;
        background: url("../../assets/images/students_grade.png") no-repeat;
        background-size: 100% 100%;
        font-size: 70px;
        font-weight: 500;
        color: #ffffff;

        .score {
          margin-bottom: 30px;
        }

        .text {
          margin-left: 8px;
          margin-top: 0;
          font-size: 24px;
        }
      }

      .teacher_li {
        margin-left: -10px;
        float: left;
        width: 695px;
        /*height: 280px;*/

        li {
          width: 190px;
          padding: 25px 10px;
          float: left;
          margin-left: 20px;
          margin-bottom: 20px;
          height: 280px;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .2);
          box-sizing: border-box;

          .teacher_img {
            display: block;
            width: 80px;
            height: 80px;
            margin: 0 auto;

            img {
              border-radius: 50%;
            }
          }

          .student_img {
            width: 60px;
            height: 60px;
          }

          .teacher_user {
            display: block;
            text-align: center;
            font: bold 14px/40px "Microsoft YaHei";
            color: #666666;
          }

          .student_user {
            font-weight: 100;
            color: #535353;
          }

          .teacher_fen {
            display: block;
            text-align: center;
            font: bold 36px/56px "Microsoft YaHei";
            color: #fea200;
          }

          .student_fen {
            font: 14px/46px "Microsoft YaHei";
          }

          .teacher_fen_txt {
            display: block;
            text-align: center;
            font: 12px/30px "Microsoft YaHei";
            color: #333333;
          }

          .teacher_intro_txt {
            display: block;
            padding-top: 8px;
            text-align: center;
            font: 12px/16px "Microsoft YaHei";
            color: #666666;
          }
        }
      }

      .student_li {
        /*padding-top: 35px;*/
        li {
          height: 220px;
        }
      }
    }

    .rsfe {
      display: block;
      text-align: center;
      font: bold 30px/74px "Microsoft YaHei";
      color: #333;
    }

    .block_fen {
      width: 410px;
      margin: 0 auto;

      span {
        display: block;
        float: left;
        width: 45px;
        font: bold 14px/38px "Microsoft YaHei";
        color: #333;
        text-align: center;
      }

      .block {
        width: 320px;
        float: left;
      }
    }

    .el-button--primary {
      margin: 30px auto 0;
      display: block;
    }
  }

  .line {
    width: 100%;
    padding: 20px 0 0 0;
    border-top: 1px solid rgba(240, 240, 240, 1);
  }

  .intro_share {
    width: 96px;
    height: 36px;
    margin: 0 auto;
    padding: 0 40px 40px 0;
    text-align: right;

    div {
      width: 96px;
      height: 36px;
      padding: 4px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: MicrosoftYaHeiUI;
      color: rgba(21, 193, 228, 1);
      text-align: center;
      background: rgba(21, 193, 228, 0.07);
      border-radius: 4px;
      border: 1px solid rgba(21, 193, 228, 1);
      box-sizing: border-box;
      cursor: pointer;

      img {
        width: 20px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }

  .alert .el-button--primary {
    margin: 0 10px;
    display: inline-block;
  }

  .alert .el-select {
    width: 100%;
  }

  .alert .el-dialog--center {
    width: 480px;
  }
}

.shareDialog .el-dialog__body {
  padding: 0 !important;
}

.shareDialog .el-dialog__header {
  padding: 0;
}

.share-wrapper {
  width: 300px;
  height: 500px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;

  .bg-row {
    width: 300px;
    height: 200px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;

    .picture {
      width: 160px;
      height: 200px;
      margin: 0 auto;
      border: 10px solid #ffffff;
      box-sizing: border-box;
      position: absolute;
      left: 70px;
      bottom: -50px;
      z-index: 99;
      filter: blur(3px);

      img {
        width: 100%;
        height: 100%;
      }
    }

    .line-canvas {
      width: 100%;
      height: 50px;
      position: absolute;
      bottom: -8px;
      left: 0;
      z-index: 10;
    }

    &:after {
      content: "";
      width: 100%;
      height: 200px;
      position: absolute;
      left: 0;
      top: 0;
      background: inherit;
      filter: blur(3px);
      z-index: 2;
    }
  }

  .qrcode-row {
    width: 250px;
    height: 100px;
    margin: 80px auto 60px auto;
    position: relative;
    text-align: center;
    background: url("../../assets/images/share_wordbg@2x.png") no-repeat;
    background-size: 100% 100%;
    background-position: 100% 100%;

    .text {
      position: absolute;
      left: 30px;
      top: 26px;
      font-size: 16px;
      color: #ffffff;

    }

    #qrcode {
      width: 60px;
      height: 60px;
      text-align: center;
      position: absolute;
      top: 22px;
      right: 22px;

      img {
        width: 60px;
        height: 60px;
        margin: 0 auto;
      }
    }
  }

  .logo {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    display: block;
  }
}

.share-canvas {
  height: 500px;
}
</style>

